/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientScheduledReportResponse {
    id?: string;
    name?: string;
    screens?: Array<'OVERVIEW' | 'COVERAGE_DASHBOARD' | 'COVERAGE_ANALYSIS' | 'BRANDS' | 'TOPICS' | 'SENTIMENT' | 'MEDIA'>;
    filtersJson?: string;
    frequency?: 'WEEKLY' | 'MONTHLY';
    recipients?: Array<string>;
    createdAt?: Date;
}
